import { styled } from 'parkdepot-shared/theme'

// TODO: check all this
const FlexContainer = styled<
    'div',
    {
        gap?: string
        margintop?: string
        marginbottom?: string
        alignitems?: string
        justifycontent?: string
        $padding?: string
        $column?: boolean
        $fullWidth?: boolean
    }
>(
    'div',
    ({ gap, margintop, marginbottom, alignitems, justifycontent, $padding, $column = false, $fullWidth = false }) => ({
        display: 'flex',
        gap,
        alignItems: alignitems || 'center',
        marginTop: margintop || 0,
        marginBottom: marginbottom || 0,
        ...(justifycontent && { justifyContent: justifycontent }),
        ...($padding && { padding: $padding }),
        ...($column && { flexDirection: 'column' }),
        ...($fullWidth && { width: '100%' })
    })
)

export default FlexContainer
